import { LegacyCard, IndexTable, Text, Link, LegacyStack, Pagination, Divider } from '@shopify/polaris';
import { useEffect, useState, useContext, forwardRef, useImperativeHandle } from 'react';
import { useHistory } from 'react-router-dom';
import { SET_ERROR } from '../../../context/ToastReducer';
import ToastContext from '../../../context/ToastContext';
import { getCustomersList } from '../../../services/customersService';

const ListCustomers = forwardRef(({ page }, ref) => {
  const [, dispatchToast] = useContext(ToastContext);
  const history = useHistory();
  const showDepositEndpoint = (id) => `/customers/${id}/?r=${window.btoa('/customers/page/' + response.metadata.page)}`;

  const [response, setResponse] = useState(null);
  const [rows, setRows] = useState([]);

  useImperativeHandle(ref, () => ({
    last(e = { new: false }) {
      callDB(e.new ? Math.ceil((response.metadata.count + 1) / response.metadata.limit) : response.metadata.lastPage);
    },
  }));

  const callDB = (page = 1, limit = 10) => {
    getCustomersList({ page, limit })
      .then((res) => {
        setResponse(res.data);
        history.push(`/customers/page/${page}`);
      })
      .catch((e) => {
        dispatchToast({ type: SET_ERROR, payload: e.response.data });
        callDB();
      });
  };

  useEffect(() => {
    callDB(page);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    response && setRows(response.data.map((r, k) => rowMarkup(r, k)));
    // eslint-disable-next-line
  }, [response]);

  const headingMarkup = [
    { title: 'Nombre' },
    { title: 'Email' },
    { title: 'País' },
    { title: 'Ciudad' },
    { title: 'Pedidos' },
  ];

  const rowMarkup = ({ id, name, email, country, city, ordersCount }, index) => (
    <IndexTable.Row id={id} key={id} position={index}>
      <IndexTable.Cell>
        <Link dataPrimaryLink url={showDepositEndpoint(id)}></Link>
        <Text variant="bodyMd" fontWeight="bold" as="span">
          {name}
        </Text>
      </IndexTable.Cell>
      <IndexTable.Cell>
        <Text>{email}</Text>
      </IndexTable.Cell>
      <IndexTable.Cell>
        <Text>{country}</Text>
      </IndexTable.Cell>
      <IndexTable.Cell>
        <Text>{city}</Text>
      </IndexTable.Cell>
      <IndexTable.Cell>
        <Text>{ordersCount}</Text>
      </IndexTable.Cell>
    </IndexTable.Row>
  );

  return <>
    {response && (
      <>
        <IndexTable
          resourceName={{
            singular: 'Cliente',
            plural: 'Clientes',
          }}
          itemCount={rows.length}
          headings={headingMarkup}
          selectable={false}
        >
          {rows}
        </IndexTable>
        <Divider borderStyle="divider" />
        <LegacyCard.Section>
          <LegacyStack distribution="center">
            <Pagination
              hasPrevious={response.metadata.prev}
              onPrevious={() => callDB(response.metadata.page - 1, response.metadata.limit)}
              hasNext={response.metadata.next}
              onNext={() => callDB(response.metadata.page + 1, response.metadata.limit)}
            />
          </LegacyStack>
        </LegacyCard.Section>
      </>
    )}
  </>;
});

export default ListCustomers;
